/* eslint-disable prefer-destructuring */
/* eslint-disable no-unused-vars */
// import firebase from "firebase/compat/app";
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth} from "firebase/auth";
import { notification } from "antd";
import UsersApi from "../api/User";
import CookieApi from "../api/Cookie";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
}

const firebaseApp = initializeApp(firebaseConfig);

export const firebaseAuth = getAuth(firebaseApp);
export const firebaseDatabase = getDatabase(firebaseApp);

export async function register(payload) {
  const { email } = payload;
  window.localStorage.setItem('emailForSignIn', email);
  const registeredUser = await UsersApi.SelfRegistration(payload);
  return registeredUser;
}

export async function logout() {
  try {
    return firebaseAuth.signOut().then(async () => {
      await CookieApi.deleteHttpOnlyCookie();
    });
  } catch (error) {
    notification.error({
      message: `Logout Error ${error?.code? error.code : ''}`,
      description: error?.message || "Something wen't wrong during logout"
    });
  }
}

export { firebaseApp };